export default {"src":"/_next/static/media/chevron-left.b4008507.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};